import * as React from 'react';
import { navMenuItemStyle, getNavMenuItemHoverStyle } from '../../styles/globalStyles';
import { useSidebarColors } from '../../styles/themeMode';

interface HoverableNavItemProps {
    children: React.ReactNode;
    onClick?: () => void;
    isSelected?: boolean;
    isDisabled?: boolean;
    style?: React.CSSProperties;
}

export const HoverableNavItem: React.FC<HoverableNavItemProps> = ({
    children,
    onClick,
    isSelected = false,
    isDisabled = false,
    style,
}) => {
    const sc = useSidebarColors();
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <div
            style={{
                ...navMenuItemStyle,
                ...(isHovered || isSelected ? getNavMenuItemHoverStyle(sc) : {}),
                ...(isDisabled && { opacity: 0.5, cursor: 'not-allowed' }),
                ...style,
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={isDisabled ? undefined : onClick}
        >
            {children}
        </div>
    );
};
